'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function IcTxtMainCategoryStock(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_IcTxtMainCategoryStock');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.02 9.09998C4.88 8.55998 6.92 7.83998 8.24 6.91998L15.42 9.09998L16.22 6.97998L9.84 5.09998C10 4.75998 10.1 4.39998 10.16 4.01998H15.28V1.83998H2.34V4.01998H7.6C7.1 5.15998 5.2 6.23998 1.38 6.99998L2.02 9.09998ZM0 12H17.6V9.81998H0V12ZM6.58 13.44C3.6 13.44 1.86 14.92 1.86 16.9C1.86 18.9 3.6 20.36 6.58 20.36H11.02C14.02 20.36 15.76 18.9 15.76 16.9C15.76 14.92 14.02 13.44 11.02 13.44H6.58ZM7.06 18.16C5.2 18.16 4.4 17.66 4.4 16.88C4.4 16.1 5.2 15.64 7.06 15.64H10.56C12.42 15.64 13.2 16.1 13.2 16.88C13.2 17.66 12.42 18.16 10.56 18.16H7.06Z",
    fill: fill || 'black'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5648 14.06H32.3048V16.26H34.8648V1.47998H32.3048V12.04H27.5648V14.06ZM23.2848 10.96C23.2048 12.04 23.1048 13.12 22.9848 14.32L25.4248 14.46C25.5648 13.18 25.6848 12 25.7648 10.86C27.6048 10.76 29.5448 10.58 31.2448 10.34L30.9848 8.21998L29.3048 8.39998C29.5448 6.73998 29.6848 4.95998 29.6848 3.17998V2.17998H20.0648V4.35998H27.2048C27.1848 5.47998 27.0448 6.99998 26.7848 8.61998C25.0848 8.73998 23.4648 8.79998 22.2248 8.79998H18.8648L18.9648 10.98H21.9848C22.4048 10.98 22.8248 10.98 23.2848 10.96ZM24.5448 15.06H21.9848V20.16H35.5448V17.84H24.5448V15.06Z",
    fill: fill || 'black'
  }));
}
var IcTxtMainCategoryStock$1 = /*#__PURE__*/memo(IcTxtMainCategoryStock);

export { IcTxtMainCategoryStock$1 as default };
